import { makeStyles } from "@material-ui/core";

export const useMessagesHeaderStyles = makeStyles(() => ({
    header: {
        width: 416
    },
    iconGroup: {
        marginLeft: "auto",
        marginRight: 10
    }
}));
